import Factory from '../utils/factory'
import Address from '../Address'
import Billing from '../Billing'
import Publishing from './publishing'

export default Factory({
  id: null,
  media: {
    logo: null,
    logoInverted: null,
    favicon: null,
    cover: null,
    gallery: null,
    brochure: null,
    attachments: null,
  },
  contractTemplates: {
    bid: null,
    bidAttachments: null,
    shop: null,
    shopCover: null,
    shopAttachments: null,
  },
  name: null,
  theme: 'skake',
  themeColor: '#1d56d8',
  themeColorSecondary: null,
  description: null,
  address: Address(),
  publishing: Publishing(),
  customFields: null,
  customFieldsConfig: [],
  metadata: {
    siteSettings: {
      hideNoOpenhouse: false,
      showSoldResidentials: false,
      hideLeadUpsell: false,
      hideShop: false,
      brochureDownloadStrategy: 'direct',
    },
  },
  inject: {
    css: null,
    js: null,
  },
  billing: null,
})
